import { defineComponent as _defineComponent } from 'vue'
import WistiaVideo from '~/components/WistiaVideo.vue';
import { showVideoContent } from '~/utils/resource';
import { Resource } from '~/types/resource';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceContent',
  props: {
    resource: null
  },
  setup(__props: any) {



return { __sfc: true,WistiaVideo, showVideoContent }
}

})